import { GlobalSiteDomainEnum } from '../types/GlobalSiteDomainEnum'

export const defaultDomainEnum = GlobalSiteDomainEnum.StandardPay

export const retrieveSiteDomainEnum = (): GlobalSiteDomainEnum => {
  if (typeof window !== 'undefined') {
    return window.location.origin.toLowerCase().includes('wastepay') ? GlobalSiteDomainEnum.WastePay : GlobalSiteDomainEnum.StandardPay
  }
  return defaultDomainEnum
}
